import PropTypes from "prop-types";
import errorShape from "./error";

const changeVisibilityShape = PropTypes.shape({
  isLoading: PropTypes.bool.isRequired,
  error: errorShape,
});

export default changeVisibilityShape;
